import BaseHttpService from "../baseService";

class ConfigServiceProvider extends BaseHttpService {
	constructor() {
		super("baazar-configs");
	}

	/**
	 * Get Baazar Configs
	 *
	 * @async
	 * @version 1.0.0
	 */
	public getConfigs(): HttpService.BaseResponse<BaseTypesModel.BaazarConfig> {
		return this.getResource().get("get-configs");
	}
}

const ConfigService = new ConfigServiceProvider();

export default ConfigService;
